module.exports = __webpack_public_path__ + "img/Dashborar_Orange_Icon.3536ae1d.png";